import React, { useState } from "react";
import {
  CCol,
  CForm,
  CFormGroup,
  CInput,
  CInputCheckbox,
  CLabel,
  CSwitch,
} from "@coreui/react";
import PropTypes from "prop-types";

export const ScoreDatasetAdvancedOptions = (props) => {
  const [isAdvancedAnalyticOptions, setIsAdvancedAnalyticOptions] =
    useState(false);

  return (
    <>
      <div
        style={
          props.isModal
            ? { float: "right", marginLeft: "15px" }
            : { float: "left", marginRight: "15px" }
        }
      >
        <CLabel
          htmlFor="advanced-analytic-options-switch"
          style={{ marginRight: "5px" }}
        >
          <i>Advanced Options</i>
        </CLabel>
        <div
          style={
            props.isModal
              ? { float: "right", marginLeft: "15px" }
              : { float: "left", marginRight: "15px" }
          }
        >
          <CSwitch
            id="advanced-analytic-options-switch"
            color={"info"}
            size={"sm"}
            checked={isAdvancedAnalyticOptions}
            onChange={(e) => {
              setIsAdvancedAnalyticOptions(e.target.checked);
            }}
          />
        </div>
      </div>
      <div //hide when isAdvancdeAnalyticOptions is false
        style={{
          display: isAdvancedAnalyticOptions ? "block" : "none",
          marginTop: "20px",
        }}
      >
        <CForm>
          <CFormGroup row>
            <CCol md="8">
              <CLabel htmlFor="limitScoredRecords" className="col-form-label">
                Limit Records Scoring to N Records{" "}
                <span className="optionaltext">(optional)</span>
              </CLabel>
            </CCol>
            <CCol md="4">
              <CInput
                id="limitScoredRecords"
                value={props.limitScoredRecords}
                onChange={(e) => props.setLimitScoredRecords(e.target.value)}
                type="number"
              />
            </CCol>
          </CFormGroup>
          <CFormGroup row>
            <CCol md="8">
              <CLabel htmlFor="onlyNew" className="col-form-label">
                Score only new records <br />
                <span style={{ fontSize: "75%" }}>
                  <i>
                    Records that had been previously scored but have been
                    updated will be EXCLUDED from the scoring job
                  </i>
                </span>
              </CLabel>
            </CCol>
            <CCol md="4">
              <div // float in the middle
                style={{ textAlign: "right" }}
              >
                <CInputCheckbox
                  id="onlyNew"
                  checked={props.onlyNew}
                  onChange={(e) => props.setOnlyNew(e.target.checked)}
                />
              </div>
            </CCol>
          </CFormGroup>
        </CForm>
      </div>
    </>
  );
};

ScoreDatasetAdvancedOptions.propTypes = {
  setOnlyNew: PropTypes.func.isRequired,
  setLimitScoredRecords: PropTypes.func.isRequired,
  limitScoredRecords: PropTypes.string,
  onlyNew: PropTypes.bool,
  isModal: PropTypes.bool,
};
